import { RouteConfig } from 'vue-router'

const router: RouteConfig[] = [
  {
    path: '/account',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      { path: '', component: () => import('pages/Account/Index.vue') }
    ],
    meta: { requiresAuth: true }
  }
]

export default router
